



















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

@Component({
    inheritAttrs: false
})
export default class Testimonial extends Vue {
    // Fields
    public showPopup = false;

    // Component Properties
    @Prop({ required: true })
    public authorName!: string;

    @Prop({ required: true })
    public authorTitle!: string;

    @Prop({ required: true })
    public company!: string;

    @Prop({ required: true })
    public shortComment!: string;

    @Prop({ required: false })
    public fullComment?: string;
}
